import { render, staticRenderFns } from "./DiscountLvTitle.vue?vue&type=template&id=6fbd75b9&scoped=true&"
import script from "./DiscountLvTitle.vue?vue&type=script&lang=js&"
export * from "./DiscountLvTitle.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLvTitle.vue?vue&type=style&index=0&id=6fbd75b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd75b9",
  null
  
)

export default component.exports